<template>
  <router-link v-if="!disabled" v-bind="$attrs">
    <slot />
  </router-link>

  <div v-else v-bind="$attrs">
    <slot />
  </div>
</template>

<script>
export default {
  name: "bg-optional-link",

  props: {
    params: Object,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
